var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.647026 8.04111C0.783461 8.17754 1.00517 8.17754 1.1416 8.04111L5.49044 3.68374L9.8478 8.04111C9.98424 8.17754 10.2059 8.17754 10.3424 8.04111C10.4788 7.90467 10.4788 7.68297 10.3424 7.54653L5.74625 2.95041C5.67803 2.88219 5.59276 2.84809 5.49896 2.84809C5.41369 2.84809 5.31989 2.88219 5.25168 2.95041L0.655554 7.54653C0.510592 7.68297 0.510592 7.90467 0.647026 8.04111Z",
    fill: "#07AFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.a9e55bd1b5285a1e87631f11a702e459.svg";
export { ForwardRef as ReactComponent };